import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthService } from '../../services/user-auth.service';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { TelemetryService } from '../../services/telemetry.service';

@Component({
  selector: 'not-authorized',
  templateUrl: './not-authorized.component.html',
  styleUrls: ['./not-authorized.component.scss'],
  imports: [
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    FlexLayoutModule
  ]
})
export class NotAuthorizedComponent {
  constructor(
    public router: Router,
    public userService: UserAuthService,
    public telemetryService: TelemetryService
  ) { }

  public goHome(): void {
    this.userService.goHome();
  }

  public logout(): void {
    this.telemetryService.trackAuthLogout(this.userService.getUsername());
    this.userService.logout();
  }
}
